export default {
  Search: {
    Lead: 'lead',
    Agency: 'agency',
    Agent: 'agent',
    Address: 'address',
    Suburb: 'suburb',
  },
  Input: {
    Text: 'text',
    Email: 'email',
    Phone: 'phone',
    Password: 'password',
  },
  Validation: {
    MustMatch: 'mustMatch',
    MustNotMatch: 'mustNotMatch',
  },
};
